import { ExtraContentsScreen } from '@screens/ExtraContentsScreen'

export default function ExtraContent() {
  return <ExtraContentsScreen />
}
